/* Mairaz review area behaviour.

   TWO JOBS.

   1. #reviews and #write-review are owned here. The element with id="reviews"
      is a zero-height marker (sections/mairaz-review-anchor.liquid), so the
      browser cannot jump to it usefully on its own. Any link that carries
      data-mrz-review-link is intercepted and scrolled to the Judge.me widget
      instead. A plain href="#reviews" without that attribute does nothing, so
      every such link in the theme must carry it.

   2. It closes the review widget with a link to every review in the shop.
      THIS IS THE POINT OF THE FILE, not a decoration. The product page opens
      with "4.9 from 1,800+ reviews" and that link scrolls here. On a product
      with five reviews of its own the shopper arrived at a widget headed
      "5 reviews" with no route to the rest, so the page appeared to promise
      eighteen hundred and deliver five. Reported 20 Sep 2026.

      The panel is now appended after the widget on EVERY product page, worded
      for whichever case applies, carrying the real figures from the anchor's
      data attributes. Nothing here types a review count: the numbers come from
      Judge.me metafields and move on their own.

   PLACEMENT DOES NOT WAIT FOR JUDGE.ME.
   The first version of this hung the panel off waitForWidget(), which gives up
   after five seconds. Judge.me loads its widget lazily and regularly takes
   longer than that on a product page, so the panel simply never appeared. It
   now places itself against the review app block's own <section>, which is in
   the server-rendered HTML from the start and sits immediately after the
   anchor's section. The poll below still prefers the widget's real section
   when it shows up quickly, so placement is exact in the common case and
   guaranteed in the slow one. If Judge.me fails to load entirely the link is
   still there, which is the behaviour we want.

   It is inserted as a sibling AFTER that section rather than inside the
   widget, because Judge.me replaces its own innerHTML when a shopper sorts,
   filters or pages, which would wipe out anything nested in it.
*/
(function () {
  'use strict';

  var REVIEW_HASH = '#reviews';
  var WRITE_REVIEW_HASH = '#write-review';
  var CTA_FLAG = 'data-mrz-all-reviews-cta';
  var WIDGET_SELECTORS = [
    '#judgeme_product_reviews',
    '.jdgm-rev-widg',
    '.jdgm-widget.jdgm-review-widget',
    '[data-widget="review-widget"]',
    '[data-widget*="review-widget"]'
  ];
  var WRITE_LINK_SELECTORS = [
    '.jdgm-write-rev-link',
    'a.jdgm-write-rev-link',
    'button.jdgm-write-rev-link',
    '[data-action="write-review"]',
    '[data-action*="write"]'
  ];

  function reviewAnchor() {
    return document.getElementById('reviews');
  }

  function anchorSection() {
    var anchor = reviewAnchor();
    return anchor && anchor.closest ? anchor.closest('.shopify-section') : null;
  }

  function followsAnchor(anchor, node) {
    if (!anchor || !node || anchor === node) return false;
    return Boolean(anchor.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function isUsable(node) {
    return Boolean(node && (node.offsetHeight || node.offsetWidth || node.getClientRects().length));
  }

  function findReviewWidget() {
    var anchor = reviewAnchor();
    if (!anchor) return null;

    for (var i = 0; i < WIDGET_SELECTORS.length; i += 1) {
      var nodes = document.querySelectorAll(WIDGET_SELECTORS[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        if (followsAnchor(anchor, nodes[j]) && isUsable(nodes[j])) return nodes[j];
      }
    }

    return null;
  }

  function findWriteReviewControl(widget) {
    if (!widget) return null;

    for (var i = 0; i < WRITE_LINK_SELECTORS.length; i += 1) {
      var control = widget.querySelector(WRITE_LINK_SELECTORS[i]);
      if (control && isUsable(control)) return control;
    }

    var clickable = widget.querySelectorAll('a, button');
    for (var j = 0; j < clickable.length; j += 1) {
      var label = String(clickable[j].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if ((label === 'write a review' || label === 'leave a review' || label === 'write review') && isUsable(clickable[j])) {
        return clickable[j];
      }
    }

    return null;
  }

  function anchorNumber(name) {
    var anchor = reviewAnchor();
    if (!anchor) return 0;
    var value = Number(anchor.getAttribute(name) || '0');
    return isFinite(value) && value > 0 ? value : 0;
  }

  function groupDigits(value) {
    return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function starsFor(rating) {
    var filled = Math.round(rating || 0);
    var out = '';
    for (var i = 1; i <= 5; i += 1) out += i <= filled ? '★' : '☆';
    return out;
  }

  function arrowIcon() {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M3 8h9M9 4.5 12.5 8 9 11.5');
    svg.appendChild(path);
    return svg;
  }

  function leadTextFor(productCount) {
    if (productCount > 1) return 'Those are all ' + groupDigits(productCount) + ' reviews written for this style.';
    if (productCount === 1) return 'That is the only review written for this style so far.';
    return 'No one has reviewed this style yet.';
  }

  function buildCta() {
    var anchor = reviewAnchor();
    if (!anchor) return null;

    var storeCount = anchorNumber('data-mrz-store-review-count');
    var productCount = anchorNumber('data-mrz-product-review-count');
    var rating = Number(anchor.getAttribute('data-mrz-store-rating') || '0');
    var url = anchor.getAttribute('data-mrz-store-reviews-url') || '/pages/customer-reviews#judgeme_all_reviews_page';

    var panel = document.createElement('aside');
    panel.className = 'mrz-arc';
    panel.setAttribute(CTA_FLAG, '');
    panel.setAttribute('aria-label', 'All Mairaz customer reviews');

    var lead = document.createElement('p');
    lead.className = 'mrz-arc__lead';
    lead.textContent = leadTextFor(productCount);
    panel.appendChild(lead);

    var sub = document.createElement('p');
    sub.className = 'mrz-arc__sub';
    if (storeCount > 0 && rating > 0) {
      var stars = document.createElement('span');
      stars.className = 'mrz-arc__stars';
      stars.setAttribute('aria-hidden', 'true');
      stars.textContent = starsFor(rating);
      sub.appendChild(stars);
      sub.appendChild(document.createTextNode(
        ' ' + rating.toFixed(1) + ' out of 5 from ' + groupDigits(storeCount) + ' reviews across every Mairaz style.'
      ));
    } else if (storeCount > 0) {
      sub.textContent = groupDigits(storeCount) + ' reviews across every Mairaz style.';
    } else {
      sub.textContent = 'Read what customers say across every Mairaz style.';
    }
    panel.appendChild(sub);

    var cta = document.createElement('a');
    cta.className = 'mrz-arc__cta';
    cta.href = url;
    var label = document.createElement('span');
    label.textContent = storeCount > 0
      ? 'Read all ' + groupDigits(storeCount) + ' reviews'
      : 'Read all customer reviews';
    cta.appendChild(label);
    cta.appendChild(arrowIcon());
    panel.appendChild(cta);

    return panel;
  }

  /* Prefer the widget's own section. Fall back to the section that follows the
     anchor, which is the review app block and is present from first paint. */
  function ctaHost() {
    var widget = findReviewWidget();
    if (widget) return (widget.closest && widget.closest('.shopify-section')) || widget;

    var section = anchorSection();
    if (!section) return null;

    var next = section.nextElementSibling;
    if (next && next.classList && next.classList.contains('shopify-section')) return next;
    return section;
  }

  function ctaPlaced() {
    return Boolean(document.querySelector('[' + CTA_FLAG + ']'));
  }

  function placeCta() {
    if (ctaPlaced()) return true;
    if (!reviewAnchor()) return true;

    var host = ctaHost();
    if (!host || !host.parentNode) return false;

    var panel = buildCta();
    if (!panel) return false;

    host.parentNode.insertBefore(panel, host.nextSibling);
    return true;
  }

  /* Give Judge.me a short head start so the panel lands against the real
     widget, then place it regardless. 20 x 300ms is six seconds. */
  function pollForCta() {
    if (!reviewAnchor() || ctaPlaced()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (ctaPlaced()) {
        window.clearInterval(timer);
        return;
      }
      if (findReviewWidget() || attempts >= 20) {
        placeCta();
        window.clearInterval(timer);
      }
    }, 300);
  }

  function scrollToNode(node, behavior) {
    if (!node || typeof node.scrollIntoView !== 'function') return;
    try {
      node.scrollIntoView({ behavior: behavior || 'auto', block: 'start' });
    } catch (error) {
      node.scrollIntoView(true);
    }
  }

  function waitForWidget(timeout) {
    return new Promise(function (resolve) {
      var existing = findReviewWidget();
      if (existing) {
        resolve(existing);
        return;
      }

      var settled = false;
      var observer = null;
      var timer = null;

      function finish(node) {
        if (settled) return;
        settled = true;
        if (observer) observer.disconnect();
        if (timer) window.clearTimeout(timer);
        resolve(node || null);
      }

      if ('MutationObserver' in window && document.body) {
        observer = new MutationObserver(function () {
          var widget = findReviewWidget();
          if (widget) finish(widget);
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }

      timer = window.setTimeout(function () {
        finish(findReviewWidget());
      }, timeout || 5000);
    });
  }

  function focusAnchor() {
    var anchor = reviewAnchor();
    if (!anchor) return;
    try {
      anchor.focus({ preventScroll: true });
    } catch (error) {
      anchor.focus();
    }
  }

  function enhanceReviewScroll(options) {
    var anchor = reviewAnchor();
    if (!anchor) return;

    var behavior = options && options.behavior ? options.behavior : 'auto';
    var shouldFocus = Boolean(options && options.focus);

    if (shouldFocus) focusAnchor();
    scrollToNode(findReviewWidget() || anchor, behavior);

    waitForWidget(5000).then(function (widget) {
      if (widget) scrollToNode(widget, behavior === 'smooth' ? 'smooth' : 'auto');
    });
  }

  function openWriteReview(options) {
    var anchor = reviewAnchor();
    if (!anchor) return;

    var behavior = options && options.behavior ? options.behavior : 'auto';

    waitForWidget(5000).then(function (widget) {
      if (!widget) {
        scrollToNode(anchor, behavior);
        return;
      }

      scrollToNode(widget, behavior);

      function activate() {
        var control = findWriteReviewControl(widget);
        if (!control) return false;
        try {
          control.click();
        } catch (error) {
          control.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        }
        return true;
      }

      if (!activate()) {
        window.setTimeout(activate, 350);
        window.setTimeout(activate, 900);
        window.setTimeout(activate, 1600);
      }
    });
  }

  function samePageHash(link, hash) {
    try {
      var url = new URL(link.href, window.location.href);
      return url.hash === hash &&
        url.origin === window.location.origin &&
        url.pathname === window.location.pathname &&
        url.search === window.location.search;
    } catch (error) {
      return false;
    }
  }

  document.addEventListener('click', function (event) {
    var leaveLink = event.target.closest ? event.target.closest('a[data-mrz-leave-review-link]') : null;
    if (leaveLink && samePageHash(leaveLink, WRITE_REVIEW_HASH)) {
      event.preventDefault();

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', WRITE_REVIEW_HASH);
      } else {
        window.location.hash = 'write-review';
      }

      openWriteReview({ behavior: 'smooth' });
      return;
    }

    var reviewLink = event.target.closest ? event.target.closest('a[data-mrz-review-link]') : null;
    if (!reviewLink || !samePageHash(reviewLink, REVIEW_HASH)) return;

    event.preventDefault();

    if (window.location.hash !== REVIEW_HASH && window.history && window.history.pushState) {
      window.history.pushState(null, '', REVIEW_HASH);
    } else if (window.location.hash !== REVIEW_HASH) {
      window.location.hash = 'reviews';
    }

    enhanceReviewScroll({ behavior: 'smooth', focus: true });
  });

  function initializeReviewArea() {
    if (!reviewAnchor()) return;
    placeCta();
    pollForCta();
    waitForWidget(5000);
  }

  function handleHash() {
    if (window.location.hash === WRITE_REVIEW_HASH) {
      window.requestAnimationFrame(function () {
        openWriteReview({ behavior: 'auto' });
      });
      return;
    }

    if (window.location.hash === REVIEW_HASH) {
      window.requestAnimationFrame(function () {
        enhanceReviewScroll({ behavior: 'auto', focus: false });
      });
    }
  }

  function ready() {
    initializeReviewArea();
    handleHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', initializeReviewArea);
  window.addEventListener('hashchange', handleHash);
})();
